import {
  Component,
  Input,
  Output,
  SimpleChange,
  EventEmitter,
  OnChanges,
  OnDestroy,
  ViewChildren,
  QueryList
} from '@angular/core';

import { Grid } from './lib/grid';
import { DataSource } from './lib/data-source/data-source';
import { Row } from './lib/data-set/row';
import { Deferred, deepExtend } from './lib/helpers';
import { LocalDataSource } from './lib/data-source/local/local.data-source';
import { ValidatorService } from './lib/validator.service';
import { SmartTableService } from '../../smart-table-service';
import { Subscription } from 'rxjs';
import { Ng2SmartTableTbodyComponent } from '../ng2-smart-table/components/tbody/tbody.component';
import { ElementRef } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'ng2-smart-table',
    templateUrl: './ng2-smart-table.component.html',
    styleUrls: ['./ng2-smart-table.component.scss'],
    standalone: false
})
export class Ng2SmartTableComponent implements OnChanges, OnDestroy {
  @Input() public source: any;
  @Input() public settings = {};

  @Output() public rowSelect = new EventEmitter<any>();
  @Output() public userRowSelect = new EventEmitter<any>();
  @Output() public delete = new EventEmitter<any>();
  @Output() public edit = new EventEmitter<any>();
  @Output() public create = new EventEmitter<any>();
  @Output() public custom = new EventEmitter<any>();
  @Output() public deleteConfirm = new EventEmitter<any>();
  @Output() public editConfirm = new EventEmitter<any>();
  @Output() public createConfirm = new EventEmitter<any>();
  @Output() public rowHover: EventEmitter<any> = new EventEmitter<any>();
  @Output() public cancelUpdate = new EventEmitter<any>();
  @Output() public add = new EventEmitter<any>();
  @Output() public cancel = new EventEmitter<any>();
  @Output() public refresh = new EventEmitter<any>();
  @Output() public save = new EventEmitter<any>();
  @Output() public changePage = new EventEmitter<any>();
  @Output() public revoke = new EventEmitter<any>();
  @Output() public undo = new EventEmitter<any>();
  @Output() public reissue = new EventEmitter<any>();
  @Output() public clear = new EventEmitter<any>();
  @Output() public checkBoxDelete = new EventEmitter<any>();
  @Output() public move = new EventEmitter<any>();
  @Output() public createPrtSet = new EventEmitter<any>();
  @Output() public linkToPrtSet = new EventEmitter<any>();
  @Output() public getHistory = new EventEmitter<any>();
  @Output() public updatePrtSet = new EventEmitter<any>();
  @Output() public blur = new EventEmitter<any>();
  @Output() public goToOffice = new EventEmitter<any>();
  @Output() public linkedPrtSets = new EventEmitter<any>();
  @Output() public linkClickEvent = new EventEmitter<any>();
  @Output() public reset = new EventEmitter<any>();

  public tableClass: string;
  public tableId: string;
  public isHideHeader: boolean;
  public isHideSubHeader: boolean;
  public isPagerDisplay: boolean;
  public rowClassFunction;
  public isBottomAction: boolean;
  public pageNumber: number;
  public removeSubscription: Subscription;
  public toggleSortingAndFilteringSubscription: Subscription;
  public toggleAddNewRecordButtonSubscription: Subscription;
  public disableRowUpdateSuccessSubscription: Subscription;
  public disableRowUpdateFailureSubscription: Subscription;
  public toggleCheckBoxSubscription: Subscription;
  public isEditMode: Subscription;
  public grid: Grid;
  public defaultSettings = {
    mode: 'inline', // inline|external|click-to-edit
    selectMode: 'multi', // single|multi
    hideHeader: false,
    hideSubHeader: false,
    actions: {
      columnTitle: 'Actions',
      add: false,
      edit: false,
      delete: false,
      reissue: false,
      revoked: false,
      undo: false,
      custom: [],
      position: 'left' // left|right
    },
    bottomActions: {
      enabled: false,
      add: {
        enabled: false,
        content: 'Add',
        class: ''
      },
      save: {
        enabled: false,
        content: 'Save',
        class: ''
      },
      getHistory: {
        enabled: false,
        content: 'Save',
        class: ''
      },
      refresh: {
        enabled: false,
        content: 'Refresh',
        class: '',
        toolTip: ''
      },
      cancel: {
        enabled: false,
        content: 'Cancel',
        class: ''
      },
      clear: {
        enabled: false,
        content: 'Clear',
        class: ''
      },
      checkBoxDelete: {
        enabled: false,
        content: 'Delete',
        class: ''
      },
      move: {
        enabled: false,
        content: 'move',
        class: ''
      },
      createPrtSet: {
        enabled: false,
        content: 'Create PrtSet',
        class: ''
      },
      linkToPrtSet: {
        enabled: false,
        content: 'Link To PrtSet',
        class: ''
      },
      updatePrtSet: {
        enabled: false,
        content: 'UpdatePrtSet',
        class: ''
      },
      linkedPrtSets: {
        enabled: false,
        content: 'Linked PrtSet',
        class: ''
      },
      goToOffice: {
        enabled: false,
        content: 'Goto Office',
        class: ''
      },
      reset: {
        enabled: false,
        content: 'Reset',
        class: '',
        toolTip: ''
      }
    },
    filter: {
      inputClass: ''
    },
    edit: {
      inputClass: '',
      editButtonContent: 'Edit',
      saveButtonContent: 'Update',
      cancelButtonContent: 'Cancel Edit',
      confirmSave: false
    },
    add: {
      inputClass: '',
      addButtonContent: 'Add New',
      createButtonContent: 'Create',
      cancelButtonContent: 'Cancel Add',
      confirmCreate: false,
      tooltip: 'tooltip.addNewButton'
    },
    delete: {
      deleteButtonContent: 'Delete',
      confirmDelete: false,
      cancelButtonContent: 'Cancel Delete'
    },
    revoke: {
      revokeButtonContent: 'Revoke',
      cancelButtonContent: 'Cancel Revoke'
    },
    undo: {
      undoButtonContent: 'Undo',
      cancelButtonContent: 'Cancel Undo'
    },
    reissue: {
      reissueButtonContent: 'Reissue',
      cancelButtonContent: 'Cancel Reissue'
    },

    attr: {
      id: '',
      class: ''
    },
    noDataMessage: '',
    columns: {},
    pager: {
      display: true,
      perPage: 10
    },
    rowClassFunction: () => ''
  };

  public isAllSelected: boolean = false;
  public gridSubscription: Subscription;
  @ViewChildren(Ng2SmartTableTbodyComponent)
  public tbody: QueryList<Ng2SmartTableTbodyComponent>;

  constructor(
    private validator: ValidatorService,
    private smartTableService: SmartTableService,
    private logger: NGXLogger
  ) {
    this.removeSubscription = this.smartTableService.onRemove.subscribe(
      (element) => {
        this.grid.deleteRow(element).then(() => {
          this.smartTableService.observable.next('');
        });
      }
    );
    this.toggleSortingAndFilteringSubscription =
      this.smartTableService.onToggleSortingAndFiltering.subscribe(
        (toggle) => {
          this.grid.toggleSorting(toggle);
          this.grid.toggleFiltering(toggle);
        }
      );
    this.toggleAddNewRecordButtonSubscription =
      this.smartTableService.onToggleAddNewRecordButton.subscribe(
        (toggle) => {
          this.grid.toggleAddNewRecordButton(toggle);
        }
      );
    this.disableRowUpdateSuccessSubscription =
      this.smartTableService.onDisableRowUpdateSuccess.subscribe(
        () => {
          this.grid.disableRowUpdateSuccess();
        }
      );
    this.disableRowUpdateFailureSubscription =
      this.smartTableService.onDisableRowUpdateFailure.subscribe(
        () => {
          this.grid.disableRowUpdateFailure();
        }
      );
    this.toggleCheckBoxSubscription =
    this.smartTableService.onToggleCheckBox.subscribe(
      () => {
        this.grid.enableCheckBox();
      }
    );
    this.isEditMode =
    this.smartTableService.onEdit.subscribe(
      () => {
          this.smartTableService.editObservable.next(this.grid.isGridinEditMode());
      }
    );
  }

  public ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
    if (this.grid) {
      if (changes['settings']) {
        this.grid.setSettings(this.prepareSettings(), this.validator);
      }
      if (changes['source']) {
        this.source = this.prepareSource();
        this.grid.setSource(this.source);
      }
    } else {
      this.initGrid();
    }
    this.tableId = this.grid.getSetting('attr.id');
    this.tableClass = this.grid.getSetting('attr.class');
    this.isHideHeader = this.grid.getSetting('hideHeader');
    this.isHideSubHeader = this.grid.getSetting('hideSubHeader');
    this.isBottomAction = this.grid.getSetting('bottomActions.enabled');
    this.isPagerDisplay = this.grid.getSetting('pager.display');
    this.rowClassFunction = this.grid.getSetting('rowClassFunction');
  }

  public ngOnDestroy() {
    // subscription remains active even after ngdestroy called
    this.removeSubscription.unsubscribe();
    this.toggleAddNewRecordButtonSubscription.unsubscribe();
    this.toggleSortingAndFilteringSubscription.unsubscribe();
    this.disableRowUpdateSuccessSubscription.unsubscribe();
    this.disableRowUpdateFailureSubscription.unsubscribe();
    this.toggleCheckBoxSubscription.unsubscribe();
    this.isEditMode.unsubscribe();
  }

  public editRowSelect(row: Row) {
    if (this.grid.getSetting('selectMode') === 'multi') {
      this.onMultipleSelectRow(row);
    } else {
      this.onSelectRow(row);
    }
  }

  public onBlur(event: any) {
    this.blur.emit({ column: event.column, validator: event.validator });
  }

  public onUserSelectRow(row: Row) {
    if (this.grid.getSetting('selectMode') !== 'multi') {
      this.grid.selectRow(row);
      this.emitUserSelectRow(row);
      this.emitSelectRow(row);
    }
  }

  public onRowHover(row: Row) {
    this.rowHover.emit(row);
  }

  public multipleSelectRow(row: Row) {
    this.grid.multipleSelectRow(row);
    this.emitUserSelectRow(row);
    this.emitSelectRow(row);
  }

  public onSelectAllRows($event: any) {
    this.isAllSelected = !this.isAllSelected;
    this.grid.selectAllRows(this.isAllSelected);

    this.emitUserSelectRow(null);
    this.emitSelectRow(null);
  }

  public onSelectRow(row: Row) {
    this.grid.selectRow(row);
    this.emitSelectRow(row);
  }

  public onMultipleSelectRow(row: Row) {
    this.emitSelectRow(row);
  }

  public initGrid() {
    this.source = this.prepareSource();
    this.grid = new Grid(this.source, this.prepareSettings(), this.validator);
    this.grid.onSelectRow().subscribe((row) => this.emitSelectRow(row));
  }

  public prepareSource(): DataSource {
    if (this.source instanceof DataSource) {
      return this.source;
    } else if (this.source instanceof Array) {
      return new LocalDataSource(this.source);
    }

    return new LocalDataSource();
  }

  public prepareSettings() {
    return deepExtend({}, this.defaultSettings, this.settings);
  }

  public OnChangePage(event: any) {
    let isEditMode = this.grid.isGridinEditMode();
    const deferred = new Deferred();
    this.resetAllSelector();
    deferred.promise
      .then((value) => {
        this.grid.toggleFiltering(true);
        this.grid.toggleSorting(true);
        this.source.setPage(event.page);
        this.grid.toggleFiltering(true);
        this.grid.toggleSorting(true);
        this.pageNumber = event.page;
        this.grid.deleteNewRows();
        this.validator.notifyOther(this.pageNumber);
      })
      .catch((err) => {
        // do nothing
        this.pageNumber = -1;
        this.validator.notifyOther(this.pageNumber);
      });
    this.changePage.emit({
      changePage: deferred,
      page: event.page,
      isEditMode
    });
  }

  public sort($event: any) {
    this.resetAllSelector();
  }

  public filter($event: any) {
    this.resetAllSelector();
  }
  public getColCount(): number {
    let count: number = this.grid.getColumns().length;

    if (this.grid.isActionsVisible) {
      count++;
    }
    if (this.grid.isMultiSelectVisible) {
      count++;
    }
    return count;
  }
  /**
   * TODO: add functionality
   */
  public onSave() {
  const rows = this.grid.getAllRecords();
  this.logger.log('records on click of save are', rows);
  this.save.emit(rows);
  }
  /**
   * TODO: add functionality
   */
  public onCancel() {
    this.cancel.emit();
  }
  /**
   * TODO: add functionality
   */
  public onRefresh() {
    let isEditMode = this.grid.isGridinEditMode();
    this.refresh.emit(isEditMode);
  }
  /**
   * TODO: add functionality
   */
  public onAdd(event: any) {
    const deferred = new Deferred();
    deferred.promise
      .then((value) => {
        this.grid.toggleSorting(false);
        this.grid.toggleFiltering(false);
        this.grid.disableCheckBoxes();
      })
      .catch((err) => {
        this.grid.toggleSortingOnCancel();
        this.grid.toggleFilteringOnCancel();
        this.grid.enableEditDelete(event.data);
      });
    this.add.emit({
      index: event.index,
      data: event.data,
      source: this.source,
      add: deferred
    });
    deferred.resolve();
  }

  public onEdit(event: any) {
    const deferred = new Deferred();
    let rowValidator = this.grid.getRowValidator(event.index, event.data.uid);
    deferred.promise
      .then((value) => {
        this.grid.toggleSorting(false);
        this.grid.toggleFiltering(false);
        this.grid.disableCheckBoxes();
      })
      .catch((err) => {
        this.grid.enableEditDelete(event.data);
      });
    this.edit.emit({
      index: event.index,
      data: event.data,
      source: this.source,
      edit: deferred,
      validator: rowValidator
    });
    deferred.resolve();
  }

  public onDelete(event: any) {
    const deferred = new Deferred();
    deferred.promise
      .then((value) => {
        this.grid.toggleSorting(false);
        this.grid.toggleFiltering(false);
        this.grid.disableCheckBoxes();
      })
      .catch((err) => {
        this.grid.enableEditDelete(event.data);
      });
    this.delete.emit({
      index: event.index,
      data: event.data,
      source: this.source,
      delete: deferred
    });
    deferred.resolve();
  }

  public onUndo(event: any) {
    const deferred = new Deferred();
    deferred.promise
      .then((value) => {
        this.grid.toggleSorting(false);
        this.grid.toggleFiltering(false);
        this.grid.disableCheckBoxes();
      })
      .catch((err) => {
        this.grid.enableEditDelete(event.data);
      });
    this.undo.emit({
      index: event.index,
      data: event.data,
      source: this.source,
      undo: deferred
    });
    deferred.resolve();
  }

  public onRevoke(event: any) {
    const deferred = new Deferred();
    deferred.promise
      .then((value) => {
        this.grid.toggleSorting(false);
        this.grid.toggleFiltering(false);
        this.grid.disableCheckBoxes();
      })
      .catch((err) => {
        this.grid.enableEditDelete(event.data);
      });
    this.revoke.emit({
      index: event.index,
      data: event.data,
      source: this.source,
      revoke: deferred
    });
    deferred.resolve();
  }

  public onReissue(event: any) {
    const deferred = new Deferred();
    deferred.promise
      .then((value) => {
        this.grid.toggleSorting(false);
        this.grid.toggleFiltering(false);
        this.grid.disableCheckBoxes();
      })
      .catch((err) => {
        this.grid.enableEditDelete(event.data);
      });
    this.reissue.emit({
      index: event.index,
      data: event.data,
      source: this.source,
      reissue: deferred
    });
    deferred.resolve();
  }

  public onClear(event: any) {
    const deferred = new Deferred();
    deferred.promise
      .then((value) => {
        //
      })
      .catch((err) => {
        // todo
      });
    this.clear.emit({
      index: event.index,
      data: event.data,
      source: this.source,
      clear: deferred
    });
    deferred.resolve();
  }

  // TODO
  public onMove(event: any) {
    let rows = this.grid.getAllCheckedRecords();
    let allRows = this.grid.getRows();
    this.move.emit({
      checkedRows: rows,
      rows: allRows
    });
  }

  public onCheckBoxDelete(event: any) {
    let rows = this.grid.getAllCheckedRecords();
    let allRows = this.grid.getRows();
    this.checkBoxDelete.emit({
      records: rows
    });
  }

  // TODO
  public onUpdatePrtSet(event: any) {
    let rows = this.grid.getAllCheckedRecords();
    this.updatePrtSet.emit({
      records: rows
    });
  }

  public onLinkedPrtSets() {
    let rows = this.grid.getAllCheckedRecords();
    this.linkedPrtSets.emit({
      records: rows
    });
  }

  // TODO
  public onLinkToPrtSet(event: any) {
    let rows = this.grid.getAllCheckedRecords();
    this.linkToPrtSet.emit({
      records: rows
    });
  }

  // TODO
  public onCreatePrtSet(event: any) {
    let rows = this.grid.getAllCheckedRecords();
    this.createPrtSet.emit({
      records: rows
    });
  }

  public ongetHistory(event: any) {
    let rows = this.grid.getAllCheckedRecords();
    this.getHistory.emit({
      records: rows
    });
  }

  public onReset(event: any) {
    let rows = this.grid.getAllCheckedRecords();
    this.reset.emit({
      records: rows
    });
  }

  public onAddCancel(event: any) {
    this.grid.toggleSortingOnCancel();
    this.grid.toggleFilteringOnCancel();
  }

  public onCancelUpdate(event: any) {
    this.grid.toggleSortingOnCancel();
    this.grid.toggleFilteringOnCancel();
    this.grid.toggleCheckBoxOnCancel();
    this.cancelUpdate.emit(event);
    this.grid.deleteNewRow(event.data, event.index);
  }
  public onGoToOffice(event: any) {
    let rows = this.grid.getAllCheckedRecords();
    this.goToOffice.emit({
      records: rows
    });
  }

  public onLinkClickEvent(row: any) {
    this.linkClickEvent.emit(row);
  }

  private resetAllSelector() {
    this.isAllSelected = false;
  }

  private emitUserSelectRow(row: Row) {
    const selectedRows = this.grid.getSelectedRows();

    this.userRowSelect.emit({
      data: row ? row.getData() : null,
      isSelected: row ? row.getIsSelected() : null,
      source: this.source,
      selected:
        selectedRows && selectedRows.length
          ? selectedRows.map((r: Row) => r.getData())
          : []
    });
  }

  private emitSelectRow(row: Row) {
    this.rowSelect.emit({
      data: row ? row.getData() : null,
      isSelected: row ? row.getIsSelected() : null,
      source: this.source
    });
  }
}
